/* eslint-disable no-unused-vars, eqeqeq, react-hooks/exhaustive-deps */
import React from "react";
import PropTypes from "prop-types";
import {Button,  ButtonBase,  CircularProgress,  Dialog,  DialogActions,  DialogContent,  DialogTitle,  IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useContext, useEffect, useRef, useState } from "react";
import { LTCPContext } from "../LTCPContext";
import { useLocation, useNavigate } from "react-router-dom";
import { getAlertData, getAlertFilters, getAlertNestedData, getCuAlertBasepackData, } from "../api/ltcpBackend";
import MultiSearchFilter from "LTCP Module/components/MultiSearchFilter";
import DownloadIcon from "@mui/icons-material/Download";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import FilterListIcon from "@mui/icons-material/FilterList";
import ExpandIcon from "LTCP Module/components/ExpandIcon";
import CollapseIcon from "LTCP Module/components/CollapseIcon";
import ltcpRoutes from "LTCP Module/constants/ltcpRoutes";
import { useMsal } from "@azure/msal-react";
import { roundOffNumber } from "utils/roundOff";
import PillBox from '../components/PillBox';
import { exportTableToExcel } from "utils/excelUtils";

// This is the table row component for all alert tables. It contain
// top level row as well as the nested rows and all the logic to pull
// the nested row data from the backend api. In nested row there is the
// redirect logic to navigate to the recommendation page for the selected
// factory - format case.
function AlertRow({
  alert,
  period,
  format,
  capacity,
  demand,
  months,
  threshold,
  cu,
  bgState,
  subcategoryState,
  factoryState,
  formatState,
  tableLevel,
  setTableLevel,
  setFormatState,
  setFactoryState,
  appliedFilters,
  setAppliedFilters,
  userEmail,
  rowIndex,
  currentFilters,
  onFormatClick,
}) {
  const navigate = useNavigate();
  const { demandFile, setLoading, runtype, runtime, branchFactoryMap } =
    useContext(LTCPContext);
  const [nestedRows, setNestedRows] = useState([]);

  let showPercentage = false;

  const capVal = roundOffNumber(capacity);
  const demandVal = roundOffNumber(demand);

  if (capVal == 0 && demandVal > 0) {
    cu = "No Capacity";
  } else if (capVal == 0 && demandVal == 0) {
    cu = "0%";
  } else {
    showPercentage = true;
    cu = roundOffNumber(cu);
  }

  function toggleClass() {
    const elmt = document.getElementById("alert-table-btn-" + rowIndex);
    if (elmt) {
      if (elmt.classList.contains("ltcp-row-expand"))
        elmt.classList.remove("ltcp-row-expand");
      else elmt.classList.add("ltcp-row-expand");
    }
  }

  async function fetchAlertNestedData() {
    if (nestedRows.length > 0) {
      setNestedRows([]);
      toggleClass();
      return;
    }

    setLoading(true);

    const data = await getAlertNestedData(userEmail, {
      demandFile,
      bgState,
      subcategoryState,
      alert,
      format,
      tableLevel,
      runtype,
      runtime,
    });

    setLoading(false);
    setNestedRows(data);
    toggleClass();
  }

  function actionHandler() {
    if (tableLevel === "factory") {
      navigate(`${ltcpRoutes.RECOMMENDATION}/${alert}/${format}`, {
        state: {
          bg: bgState,
          subcategory: subcategoryState,
          factory: factoryState,
          format: formatState,
          all_filters: currentFilters,
          applied_filters: appliedFilters,
        },
      });
    } else if (tableLevel === "branch") {
        setAppliedFilters([...appliedFilters, "factory", "format"]);
        setFactoryState(branchFactoryMap[alert]);
        setTableLevel("factory");
        setFormatState(format);
      } else {
        setAppliedFilters([...appliedFilters, "format"]);
        setTableLevel("factory");
        setFormatState(format);
      }
  }

  return (
    <>
      <TableRow>
        <TableCell
          sx={{
            gap: 1,
            fontSize: 12,
            borderBottom: "1px solid #ccc",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
          }}
        >
          <ButtonBase
            id={"alert-table-btn-" + rowIndex}
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              textWrap: "nowrap",
              fontSize: 12,
              gap: 2,
            }}
            onClick={fetchAlertNestedData}
          >
            {nestedRows.length === 0 ? <ExpandIcon /> : <CollapseIcon />}
            {alert}
          </ButtonBase>
        </TableCell>
        <TableCell sx={{ fontSize: 12, borderBottom: "1px solid #ccc" }}>
          <Typography
            component="span"
            fontSize={12}
            color="blue"
            sx={{
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() =>
              onFormatClick({
                format,
                alert,
              })
            }
          >
          {format}
          </Typography>
        </TableCell>
        <TableCell sx={{ fontSize: 12, borderBottom: "1px solid #ccc" }}>
          {period}
        </TableCell>
        <TableCell
          sx={{
            fontSize: 12,
            borderBottom: "1px solid #ccc",
            textAlign: "right",
          }}
        >
          {roundOffNumber(demand)}
        </TableCell>
        <TableCell
          sx={{
            fontSize: 12,
            borderBottom: "1px solid #ccc",
            textAlign: "right",
          }}
        >
          {roundOffNumber(capacity)}
        </TableCell>
        <TableCell
          sx={{
            fontSize: 12,
            borderBottom: "1px solid #ccc",
            textAlign: "center",
          }}
        >
          <PillBox value={`${cu}${showPercentage ? "%":""}`} bgColor = { `${runtype.toLowerCase() !== "schedule" && (cu >= threshold || cu === "No Capacity" )?"#ff9998":"White"}`}/>
        </TableCell>
        <TableCell
          sx={{
            fontSize: 12,
            borderBottom: "1px solid #ccc",
            textAlign: "center",
            color: "red",
          }}
        >
          {months}
        </TableCell>
        <TableCell sx={{ fontSize: 12, borderBottom: "1px solid #ccc" }}>
          <Typography
            color="blue"
            fontSize={12}
            sx={{
              textDecoration: "underline",
              cursor: "pointer",
              textAlign: "center",
            }}
            onClick={actionHandler}
          >
            View
          </Typography>
        </TableCell>
      </TableRow>
      {nestedRows.map((item, index) => {
        const demandValue = roundOffNumber(item.demand);
        const capacityValue = roundOffNumber(item.capacity);
        let nestedCU = roundOffNumber(item.cu);
        let showNestedPercentage = false;

        if (capacityValue === 0 && demandValue > 0) {
          nestedCU = "No Capacity";
        } else if (demandValue === 0 && capacityValue === 0) {
          nestedCU = "0%";
        } else {
          showNestedPercentage = true;
        }

        return (
          <TableRow key={item.period + index}>
            <TableCell
              sx={{
                fontSize: 12,
                borderBottom: "1px solid #ccc",
                background: "#E8F3F8",
              }}
            ></TableCell>
            <TableCell
              sx={{
                fontSize: 12,
                borderBottom: "1px solid #ccc",
                background: "#E8F3F8",
              }}
            >
              {item.format}
            </TableCell>
            <TableCell
              sx={{
                fontSize: 12,
                borderBottom: "1px solid #ccc",
                background: "#E8F3F8",
              }}
            >
              {item.period}
            </TableCell>
            <TableCell
              sx={{
                fontSize: 12,
                borderBottom: "1px solid #ccc",
                textAlign: "right",
                background: "#E8F3F8",
              }}
            >
              {roundOffNumber(item.demand)}
            </TableCell>
            <TableCell
              sx={{
                fontSize: 12,
                borderBottom: "1px solid #ccc",
                textAlign: "right",
                background: "#E8F3F8",
              }}
            >
              {roundOffNumber(item.capacity)}
            </TableCell>
            <TableCell
              sx={{
                fontSize: 12,
                borderBottom: "1px solid #ccc",
                textAlign: "center",
                background: "#E8F3F8",
              }}
            >
              <PillBox value={`${nestedCU} ${showNestedPercentage ? "%":""}`} bgColor = { `${runtype.toLowerCase() !== "schedule" && (nestedCU >= threshold || nestedCU === "No Capacity" )?"#ff9998":"White"}`}/>
            </TableCell>
            <TableCell
              sx={{
                fontSize: 12,
                borderBottom: "1px solid #ccc",
                textAlign: "center",
                color: "red",
                background: "#E8F3F8",
              }}
            ></TableCell>
            <TableCell
              sx={{
                fontSize: 12,
                borderBottom: "1px solid #ccc",
                background: "#E8F3F8",
              }}
            ></TableCell>
          </TableRow>
        );
      })}
    </>
  );
}

// Helper: Get filter width based on table level
function getFilterWidth(tableLevel) {
  return (tableLevel === 'branch' || tableLevel === 'factory') ? '24%' : '32%';
}

// Helper: Reset location states when changing table level
function handleTableLevelChange(newLevel, setTableLevel, setBranchState, setFactoryState) {
  setTableLevel(newLevel);
  setBranchState('All');
  setFactoryState('All');
}

// Helper: Get tab style based on active state
function getTabBorderStyle(isActive) {
  return isActive ? '2px solid #1F36C7' : 'none';
}

// Helper: Get sort icon based on column and order
function renderSortIcon(tableSortCol, col, tableSortOrd) {
  if (tableSortCol !== col) return null;
  return tableSortOrd ? (
    <ArrowDownwardIcon sx={{ fontSize: 12 }} />
  ) : (
    <ArrowUpwardIcon sx={{ fontSize: 12 }} />
  );
}

// Helper: Get column label with units
function getColumnLabel(col) {
  const baseLabel = col.charAt(0).toUpperCase() + col.slice(1);
  if (col === 'demand' || col === 'capacity') return `${baseLabel} (T)`;
  if (col === 'cu') return `${baseLabel}%`;
  return baseLabel;
}

// Helper: Render dialog content based on loading and data states
function renderDialogContent(cuDialogLoading, basepackCuData, thresholdCu) {
  if (cuDialogLoading) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight={160}>
        <CircularProgress size={28} />
      </Stack>
    );
  }

  if (basepackCuData.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight={120}>
        <Typography fontSize={13} color="text.secondary">
          No basepack data found.
        </Typography>
      </Stack>
    );
  }

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                bgcolor: "#354acd",
                color: "#fff",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
               Basepack
            </TableCell>
            <TableCell
              align="right"
              sx={{
                bgcolor: "#354acd",
                color: "#fff",
                fontSize: 12,
                fontWeight: "bold",
              }}
            >
              {`CU % > ${thresholdCu * 100}`}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {basepackCuData.map((row, index) => (
            <TableRow key={`${row.basepackcode}-${index}`}>
              <TableCell sx={{ fontSize: 12 }}>
                {row.basepackcode}
              </TableCell>
              <TableCell align="right" sx={{ fontSize: 12 }}>
                {roundOffNumber(row.cu_per)}%
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

// This is the alert page for both national, branch and factory level
// It contain the all the tree tabs and tab specific filters also. This
// page component is using the alert row to show the data on the tables
// in each tab.
function AlertsPage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const {
    demandFile,
    alertFilters,
    setLoading,
    runtype,
    runtime,
    thresholdLevel,
    productType,
  } = useContext(LTCPContext);
  const { accounts } = useMsal();
  const activeAccount = accounts[0];
  const userEmail = activeAccount.username;

  const tableRef = useRef(null);
  const [savedFilters, setSavedFilters] = useState(state?.all_filters || null);
  const [currentFilters, setCurrentFilters] = useState(alertFilters);
  const [bgState, setBgState] = useState(state?.bg || "All");
  const [subcategoryState, setSubcategoryState] = useState(
    state?.subcategory || "All"
  );
  const [formatState, setFormatState] = useState(state?.format || "All");
  const [branchState, setBranchState] = useState(state?.branch || "All");
  const [factoryState, setFactoryState] = useState(state?.factory || "All");
  const [tableLevel, setTableLevel] = useState(state?.tab || "national");
  const [tableSortCol, setTableSortCol] = useState("cu");
  const [tableSortOrd, setTableSortOrd] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState(
    state?.applied_filters || []
  );
  const [rowToggleState, setRowToggleState] = useState(false);
  const [thresholdValue, setThresholdValue] = useState(90);
  const [result, setResult] = useState({
    alerts_count: 0,
    data: [],
    change: 0,
    time: "",
  });

  const [cuDialogOpen, setCuDialogOpen] = useState(false);
  const [cuDialogLoading, setCuDialogLoading] = useState(false);
  const [selectedFormatForCu, setSelectedFormatForCu] = useState("");
  const [basepackCuData, setBasepackCuData] = useState([]);

  useEffect(() => {
    if (!runtime || !runtype) return navigate(ltcpRoutes.LANDING);

    if (thresholdLevel[subcategoryState]) {
      setThresholdValue(thresholdLevel[subcategoryState]);
      return;
    }

    if (currentFilters.subcategory.length === 1) {
      if (thresholdLevel[currentFilters.subcategory[0]]) {
        setThresholdValue(thresholdLevel[currentFilters.subcategory[0]]);
        return;
      }
    }

    setThresholdValue(90);
  }, [currentFilters]);

  function sortTable(col) {
    if (tableSortCol === col) {
      setTableSortOrd(!tableSortOrd);
    } else {
      setTableSortCol(col);
      setTableSortOrd(true);
    }
  }

  useEffect(() => {
    if (!runtime || !runtype) return navigate(ltcpRoutes.LANDING);

    setRowToggleState(false);
  }, [
    tableLevel,
    bgState,
    subcategoryState,
    formatState,
    branchState,
    factoryState,
  ]);

  async function fetchAlertData() {
    let locationState = undefined;

    if (tableLevel === "branch") {
      locationState = branchState;
    } else if (tableLevel === "factory") {
      locationState = factoryState;
    }

    setLoading(true);

    const resp = await Promise.all([
      getAlertFilters(userEmail, {
        demand_file: demandFile,
        bg: bgState,
        subcategory: subcategoryState,
        format: formatState,
        location: locationState,
        table_level: tableLevel,
        productType,
        runtype,
        runtime,
      }),
      getAlertData(userEmail, {
        demandFile,
        bgState,
        subcategoryState,
        formatState,
        tableLevel,
        locationState,
        productType,
        runtime,
        runtype,
      }),
    ]);

    const filters = resp[0];

    appliedFilters.forEach((filter) => {
      filters[filter] = currentFilters[filter];
    });

    setLoading(false);
    setResult(resp[1]);

    try {
      if (savedFilters) {
        setCurrentFilters(savedFilters);
        setSavedFilters(null);
      } else {
        setCurrentFilters(filters);
      }
    } catch (e) {
      setCurrentFilters(filters);
    }
  }

  function toggleAllRows() {
    result.data.forEach((_, i) => {
      const elmt = document.getElementById("alert-table-btn-" + i);

      if (elmt) {
        if (rowToggleState) {
          if (elmt.classList.contains("ltcp-row-expand")) elmt.click();
        } else if (!elmt.classList.contains("ltcp-row-expand")) elmt.click();
      }
    });

    setRowToggleState(!rowToggleState);
  }

  const exportToExcel = async () => {
    await exportTableToExcel(tableRef.current, "alert-data.xlsx");
  };

  useEffect(() => {
    fetchAlertData();
  }, [
    bgState,
    subcategoryState,
    branchState,
    factoryState,
    formatState,
    tableLevel,
  ]);

  async function handleFormatClick(selectedRow) {
  const clickedFormat = selectedRow?.format;
  const clickedAlert = selectedRow?.alert;

  let locationState = getLocationFromRowAlert(clickedAlert, tableLevel);

  // Fallback only if selected row does not have location
  if (!locationState) {
    if (tableLevel === "branch" && branchState !== "All") {
      locationState = branchState;
    } else if (tableLevel === "factory" && factoryState !== "All") {
      locationState = factoryState;
    }
  }

  try {
    setSelectedFormatForCu(clickedFormat);
    setBasepackCuData([]);
    setCuDialogOpen(true);
    setCuDialogLoading(true);

    const response = await getCuAlertBasepackData(userEmail, {
      demandFile,
      bgState,
      subcategoryState,
      format: clickedFormat,
      tableLevel,
      locationState,
      productType,
      runtime,
      runtype,
      threshold: thresholdValue,
    });

    setBasepackCuData(response?.data || []);
  } catch (error) {
    console.error("Error while fetching basepack CU data", error);
    setBasepackCuData([]);
  } finally {
    setCuDialogLoading(false);
  }
}

  return (
    <Stack p={4} py={2} gap={2} flexGrow={1}>
      <Stack direction="row" gap={2} alignItems="center" height={40}>
        <IconButton onClick={() => navigate(ltcpRoutes.DASHBOARD)}>
          <KeyboardBackspaceIcon />
        </IconButton>
        <Typography fontWeight="bold" fontSize={21}>
          Alert Details
        </Typography>
        <Stack
          direction="row"
          gap={1}
          flexGrow={1}
          maxWidth="600px"
          borderBottom="1px solid #ccc"
        >
          {['national', 'branch', 'factory'].map((level) => (
            <Typography
              key={level}
              p={0.5}
              flexGrow={1}
              fontSize={14}
              textAlign="center"
              onClick={() => handleTableLevelChange(level, setTableLevel, setBranchState, setFactoryState)}
              borderBottom={getTabBorderStyle(tableLevel === level)}
              sx={{ cursor: 'pointer' }}
            >
              {level.charAt(0).toUpperCase() + level.slice(1)}
            </Typography>
          ))}
        </Stack>
      </Stack>
      <Stack direction="row" gap={2} height={88}>
        <Paper
          sx={{
            p: 1,
            px: 2,
            width: 220,
            bgcolor: "#354acd",
            // border: "1px solid #fff",
            color:'#fff',
            display: "flex",
            alignItems: "center",
          }}
        >
          <Stack justifyContent="center">
            <Typography fontSize={11}>Count of Alerts</Typography>
            <Typography fontWeight="bold" fontSize={16}>
              {result.alerts_count}
            </Typography>
            <Stack direction="row" alignItems="center">
              <Typography fontSize={11}>
                {Math.abs(Number.parseInt(result.change))}%
              </Typography>
              {result.change >= 0 ? (
                <ArrowUpwardIcon sx={{ fontSize: 20, color: "green" }} />
              ) : (
                <ArrowDownwardIcon sx={{ fontSize: 20, color: "red" }} />
              )}
              <Typography fontSize={11}>from {result.time}</Typography>
            </Stack>
          </Stack>
        </Paper>
        <Paper
          sx={{
            p: 2,
            width: "100%",
            border: "1px solid #fff",
          }}
        >
          <Stack direction="row" gap={2}>
            <Stack gap={1} width={getFilterWidth(tableLevel)}>
              <Typography fontSize={14}>BG</Typography>
              <MultiSearchFilter
                filterName="bg"
                value={bgState}
                setValue={setBgState}
                options={currentFilters.bg}
                appliedFilters={appliedFilters}
                setAppliedFilters={setAppliedFilters}
              />
            </Stack>
            <Stack gap={1} width={getFilterWidth(tableLevel)}>
              <Typography fontSize={14}>Sub-Category</Typography>
              <MultiSearchFilter
                filterName="subcategory"
                value={subcategoryState}
                setValue={setSubcategoryState}
                options={currentFilters.subcategory}
                appliedFilters={appliedFilters}
                setAppliedFilters={setAppliedFilters}
              />
            </Stack>
            {tableLevel === 'branch' && (
              <Stack gap={1} width={getFilterWidth(tableLevel)}>
                <Typography fontSize={14}>Branch</Typography>
                <MultiSearchFilter
                  filterName="location"
                  value={branchState}
                  setValue={setBranchState}
                  options={currentFilters.location}
                  appliedFilters={appliedFilters}
                  setAppliedFilters={setAppliedFilters}
                />
              </Stack>
            )}
            {tableLevel === 'factory' && (
              <Stack gap={1} width={getFilterWidth(tableLevel)}>
                <Typography fontSize={14}>Factory</Typography>
                <MultiSearchFilter
                  filterName="location"
                  value={factoryState}
                  setValue={setFactoryState}
                  options={currentFilters.location}
                  appliedFilters={appliedFilters}
                  setAppliedFilters={setAppliedFilters}
                />
              </Stack>
            )}
            <Stack gap={1} width={getFilterWidth(tableLevel)}>
              <Typography fontSize={14}>Format L2</Typography>
              <MultiSearchFilter
                filterName="format"
                value={formatState}
                setValue={setFormatState}
                options={currentFilters.format}
                appliedFilters={appliedFilters}
                setAppliedFilters={setAppliedFilters}
              />
            </Stack>
          </Stack>
        </Paper>
      </Stack>
      <Paper
        sx={{
          px: 2,
          py: 1,
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          minHeight: "calc(100vh - 288px)",
          maxHeight: "calc(100vh - 288px)",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography fontSize={16} fontWeight="medium">
            National Level Alert Summary
          </Typography>
          <Stack direction="row" alignItems="center" gap={2}>
            {rowToggleState ? (
              <Tooltip title="Collapse rows">
                <IconButton size="small" onClick={toggleAllRows}>
                  <CloseFullscreenIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Expand rows">
                <IconButton size="small" onClick={toggleAllRows}>
                  <OpenInFullIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip>
              <IconButton size="small" onClick={exportToExcel}>
                <DownloadIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>
        <TableContainer>
          <Table stickyHeader ref={tableRef}>
            <TableHead>
              <TableRow>
                {['alert', 'format', 'period', 'demand', 'capacity', 'cu'].map((col) => (
                  <TableCell
                    key={col}
                    sx={{
                      bgcolor: "#354acd",
                      color:"#fff",
                      py: 0,
                      fontSize: 12,
                      fontWeight: "bold",
                      textAlign: col !== 'alert' && col !== 'format' && col !== 'period' ? 'center' : 'inherit',
                    }}
                    onClick={() => sortTable(col)}
                  >
                    {getColumnLabel(col)}
                    <FilterListIcon sx={{ fontSize: 12 }} />
                    {renderSortIcon(tableSortCol, col, tableSortOrd)}
                  </TableCell>
                ))}
                <TableCell
                  sx={{
                    bgcolor: "#354acd",
                    color:"#fff",
                    py: 0.5,
                    gap: 1,
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                  onClick={() => sortTable("months")}
                >
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    gap={1}
                  >
                    <Stack>
                      <Typography fontSize={10} fontWeight={500}>
                        No. of months
                      </Typography>
                      <Typography fontSize={10} fontWeight={500}>
                        {"CU>Threshold"}
                      </Typography>
                    </Stack>
                    <FilterListIcon sx={{ fontSize: 12 }} />
                    {renderSortIcon(tableSortCol, "months", tableSortOrd)}
                  </Stack>
                </TableCell>
                <TableCell
                  sx={{
                    bgcolor: "#354acd",
                    color:"#fff",
                    py: 0,
                    fontSize: 12,
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Recommendations Page
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(tableSortOrd
                ? result.data.toSorted((a, b) =>
                    typeof a[tableSortCol] === "string"
                      ? a[tableSortCol].localeCompare(b[tableSortCol])
                      : a[tableSortCol] - b[tableSortCol]
                  )
                : result.data.toSorted((a, b) =>
                    typeof a[tableSortCol] === "string"
                      ? b[tableSortCol].localeCompare(a[tableSortCol])
                      : b[tableSortCol] - a[tableSortCol]
                  )
              ).map((item, index) => (
                <AlertRow
                  key={
                    item.alert +
                    item.period +
                    item.demand +
                    item.capacity +
                    index
                  }
                  rowIndex={index}
                  period={item.period}
                  alert={item.alert}
                  months={item.months}
                  format={item.format}
                  capacity={item.capacity}
                  demand={item.demand}
                  cu={item.cu}
                  threshold={thresholdValue}
                  bgState={bgState}
                  formatState={formatState}
                  factoryState={factoryState}
                  subcategoryState={subcategoryState}
                  tableLevel={tableLevel}
                  setTableLevel={setTableLevel}
                  setFormatState={setFormatState}
                  setFactoryState={setFactoryState}
                  appliedFilters={appliedFilters}
                  setAppliedFilters={setAppliedFilters}
                  userEmail={userEmail}
                  currentFilters={currentFilters}
                  onFormatClick={handleFormatClick}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Dialog
        open={cuDialogOpen}
        onClose={() => setCuDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Stack gap={0.5}>
            <Typography fontSize={18} fontWeight="bold">
              Basepack CU Details
            </Typography>

            <Typography fontSize={13} color="text.secondary">
              Format L2: {selectedFormatForCu}
            </Typography>
          </Stack>
        </DialogTitle>

        <DialogContent dividers>
          {renderDialogContent(cuDialogLoading, basepackCuData, result?.data[0]?.thresholdcu || 0.90)}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setCuDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
}

  function getLocationFromRowAlert(rowAlert, currentTableLevel) {
  if (!rowAlert) return undefined;

  const alertValue = String(rowAlert).trim();

  if (currentTableLevel === "branch") {
    if (alertValue.startsWith("Branch:")) {
      return alertValue.replace("Branch:", "").trim();
    }

    return alertValue !== "National" ? alertValue : undefined;
  }

  if (currentTableLevel === "factory") {
    if (alertValue.startsWith("Factory:")) {
      return alertValue.replace("Factory:", "").trim();
    }

    return alertValue !== "National" ? alertValue : undefined;
  }

  return undefined;
}

AlertRow.propTypes = {
  rowIndex: PropTypes.number.isRequired,
  period: PropTypes.string.isRequired,
  alert: PropTypes.string.isRequired,
  months: PropTypes.number.isRequired,
  format: PropTypes.string.isRequired,
  capacity: PropTypes.number.isRequired,
  demand: PropTypes.number.isRequired,
  cu: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  threshold: PropTypes.number.isRequired,
  bgState: PropTypes.string.isRequired,
  formatState: PropTypes.string.isRequired,
  factoryState: PropTypes.string.isRequired,
  subcategoryState: PropTypes.string.isRequired,
  tableLevel: PropTypes.string.isRequired,
  setTableLevel: PropTypes.func.isRequired,
  setFormatState: PropTypes.func.isRequired,
  setFactoryState: PropTypes.func.isRequired,
  appliedFilters: PropTypes.array.isRequired,
  setAppliedFilters: PropTypes.func.isRequired,
  userEmail: PropTypes.string.isRequired,
  currentFilters: PropTypes.object.isRequired,
  onFormatClick: PropTypes.func.isRequired
};


export default AlertsPage;
